export enum InquiryModuleAttribute {
  Tags = 'tags',
  Name = 'name',
  GovernmentIDNumber = 'government_id_number',
  BirthDate = 'birth_date',
  Address = 'address',
  ExpirationDate = 'expiration_date',
  EmailAddress = 'email_address',
  PhoneNumber = 'phone_number',
  SocialSecurityNumber = 'ssn',
  SessionLocation = 'session_location',
  FieldNames = 'field_name',
  Photos = 'photos',
  DocumentExtraction = 'document_extractions',
}
